import React from "react";

import { SentinelInfoSection } from "./sentinel-info-section";
import { MonitorSchedules } from "src/web/components/MonitorSchedules";

export const SentinelDefaultInfoSection = () => (
    <SentinelInfoSection header="Dependency Sentinel">
        <div>
            <p>
        Dependency Sentinel is a platform that will automatically generate code reviews for 
        trivially updatable software. It will scan the software packages and gather a list of 
        dependencies. It will periodically scan for new releases and updated guidance after 
        that it will apply the guidance and produce code reviews where applicable. The 
        development team will be expected to review and merge the code reviews produced as well 
        as conduct end to end integration testing as part of their regular deployment process.
            </p>
            <h4>When data refreshes</h4>
            <p>
        Nothing on this site updates the moment you load it. Each part of the data comes
        from a scheduled run, so a change you expect to see appears after that run
        finishes:
            </p>
            <MonitorSchedules />
            <h4>Reading a timestamp</h4>
            <p>
        Where a page shows an &quot;as of&quot; date, that is when the run that produced the
        data finished. If a dependency was
        upgraded after that time, it will still show the older version until the next
        run.
            </p>
        </div>
    </SentinelInfoSection>
);
